/* Load Vue Modules */
import Vue from 'vue'
import Router from 'vue-router'
/* Store import for auto-logout */
import store from '../store'
import * as globalTypes from '../store/mutation-types.js'
/* Load Global Components */
import Login from '@/components/screens/login/login.vue'
// import MijnAccount from '@/components/screens/mijn-account/.vue'
import MijnGebruiker from '@/components/screens/mijn-gebruiker/mijn-gebruiker.vue'
import MijnGebruikerAanmaken from '@/components/screens/mijn-gebruiker/gebruiker-aanmaken/gebruiker-aanmaken.vue'
import gebruikerConfirmationcode from '@/components/screens/mijn-gebruiker/gebruiker-confirmationcode/gebruiker-confirmationcode.vue'
import MijnGebruikerWachtwoordVergeten from '@/components/screens/mijn-gebruiker/wachtwoord-vergeten/wachtwoord-vergeten.vue'
import gebruikerUsername from '@/components/screens/mijn-gebruiker/gebruiker-username/gebruiker-username.vue'
import ConnectionMaker from '@/components/screens/connection-maker/connection-maker.vue'
import Info from '@/components/screens/info/info.vue'
import LandingPage from '@/components/screens/landing-page/landing-page.vue'
import dropdownPage from '../components/utils/dropdown-page/dropdown-page.vue'
/* Load Private Components */
import showIcons from '../components/utils/_show_icons/_show_icons.vue'
/* Load student Components */
import aanwMijnGegevens from 'wisaapp-webstudent/src/components/mijn-gegevens/mijn-gegevens.vue'
import opleiding from 'wisaapp-webstudent/src/components/opleiding/opleiding.vue'
import betalingen from 'wisaapp-webstudent/src/components/betalingen/betalingen.vue'
import module from 'wisaapp-webstudent/src/components/opleiding/module.vue'
import MijnGebruikerAangemaakt from '@/components/screens/mijn-gebruiker/gebruiker-aangemaakt/gebruiker-aangemaakt.vue'
import Aanwezigheden from 'wisaapp-webstudent/src/components/Aanwezigheden/Aanwezigheden.vue'
import Agenda from 'wisaapp-webstudent/src/components/agenda/agenda.vue'

import aanwconfiguratie from 'wisaapp-webstudent/src/components/configuratie/configuratie.vue'

import MijnGebruikerWachtwoordWijzigen from '@/components/screens/mijn-gebruiker/wachtwoord-wijzigen/wachtwoord-wijzigen.vue'


Vue.use(Router)

const router = new Router({
  mode: 'hash',
  routes: [
    /* Algemeen Schermen */
    {
      path: '/',
      name: 'Main Page',
      component: Login,
      meta: {
        backButtonAllowed: true,
        moduleName: 'General',
        firstPage: false
      },
      beforeEnter: (to, from, next) => {
        // if not first opening && if not logged out
        if (from.name !== null && from.meta.moduleName !== 'Connection' && store.state.userInfo.loggedInConnectionObject !== null) {
          store.commit(globalTypes.LOGGED_OUT_ONCE)
          store.dispatch('logout')
        }
        next()
      }
    },
    // {
    //   path: '/login',
    //   name: 'Login Page',
    //   component: Login
    // },
    {
      path: '/_show_icons',
      name: 'Show Icons',
      component: showIcons,
      meta: {
        backButtonAllowed: false,
        moduleName: 'General',
        firstPage: false
      }
    },
    {
      path: '/connection/new',
      name: 'Nieuwe connectie',
      component: ConnectionMaker,
      meta: {
        backButtonAllowed: true,
        moduleName: 'Connection',
        firstPage: false
      }
    },
    {
      path: '/connection/:id/edit',
      name: 'WIjzigen connectie',
      component: ConnectionMaker,
      meta: {
        backButtonAllowed: true,
        moduleName: 'Connection',
        firstPage: false
      }
    },
    {
      path: '/info',
      name: 'Info',
      component: Info,
      meta: {
        backButtonAllowed: false,
        moduleName: 'General',
        firstPage: true
      }
    },
    // {
    //   path: '/mijn-account',
    //   name: 'Mijn account',
    //   component: MijnAccount,
    //   meta: {
    //     backButtonAllowed: true,
    //     moduleName: 'General',
    //     firstPage: true
    //   }
    // },
    {
      path: '/mijn-gebruiker',
      name: 'Mijn gebruiker',
      component: MijnGebruiker,
      meta: {
        backButtonAllowed: true,
        moduleName: 'General',
        firstPage: false
      }
    },
    {
      path: '/mijn-gebruiker/gebruiker-aanmaken/',
      name: 'Gebruiker aanmaken',
      component: MijnGebruikerAanmaken,
      meta: {
        backButtonAllowed: true,
        moduleName: 'MijnGebruiker',
        firstPage: false
      }
    },
    {
      path: '/mijn-gebruiker/gebruiker-confirmationcode/',
      name: 'Gebruiker Confirmationcode',
      component: gebruikerConfirmationcode,
      meta: {
        backButtonAllowed: true,
        moduleName: 'gebruikerConfirmationcode',
        firstPage: false
      }
    },
    {
      path: '/mijn-gebruiker/gebruiker-username/',
      name: 'Gebruiker Username',
      component: gebruikerUsername,
      meta: {
        backButtonAllowed: true,
        moduleName: 'gebruikerUsername',
        firstPage: false
      }
    },
    {
      path: '/mijn-gebruiker/wachtwoord-vergeten',
      name: 'Wachtwoord vergeten',
      component: MijnGebruikerWachtwoordVergeten,
      meta: {
        backButtonAllowed: false,
        moduleName: 'MijnGebruiker',
        firstPage: true
      }
    },
    {
      path: '/mijn-gebruiker/gebruiker-aangemaakt/',
      name: 'Gebruiker aangemaakt',
      component: MijnGebruikerAangemaakt,
      meta: {
        backButtonAllowed: false,
        moduleName: 'MijnGebruiker',
        firstPage: true
      }
    },
    {
      path: '/mijn-gebruiker/wachtwoord-wijzigen',
      name: 'Wachtwoord wijzigen',
      component: MijnGebruikerWachtwoordWijzigen,
      meta: {
        backButtonAllowed: false,
        moduleName: 'MijnGebruiker',
        firstPage: true
      }
    },
    {
      path: '/landing-page',
      name: 'Landing Page',
      component: LandingPage,
      meta: {
        backButtonAllowed: true,
        moduleName: 'General',
        firstPage: true
      }
    },
    /* Algemeen dropdown pagina */
    {
      path: '/maak-een-keuze',
      name: 'Dropdown Page',
      component: dropdownPage,
      meta: {
        backButtonAllowed: true,
        moduleName: 'General',
        firstPage: false
      }
    },
    /* student Secundaironderwijs */
    {
      path: '/mijn-gegevens',
      name: 'mijn-gegevens',
      component: aanwMijnGegevens,
      meta: {
        backButtonAllowed: true,
        moduleName: 'mijnGegevens',
        firstPage: false

      }
    },
    {
      path: '/opleiding',
      name: 'Opleiding',
      component: opleiding,
      meta: {
        backButtonAllowed: true,
        moduleName: 'opleiding',
        firstPage: false

      }
    },
    {
      path: '/betalingen',
      name: 'betalingen',
      component: betalingen,
      meta: {
        backButtonAllowed: false,
        moduleName: 'betalingen',
        firstPage: false

      }
    },
    {
      path: '/opleiding/module',
      name: 'Module',
      component: module,
      meta: {
        backButtonAllowed: false,
        moduleName: 'Module',
        firstPage: false

      }
    },
    {
      path: '/Aanwezigheden',
      name: 'Aanwezigheden',
      component: Aanwezigheden,
      meta: {
        backButtonAllowed: false,
        moduleName: 'Aanwezigheden',
        firstPage: false

      }
    },
    {
      path: '/Agenda',
      name: 'Agenda',
      component: Agenda,
      meta: {
        backButtonAllowed: false,
        moduleName: 'student',
        firstPage: true

      }
    },


    {
      path: '/configuratie',
      name: 'configuratie',
      component: aanwconfiguratie,
      meta: {
        backButtonAllowed: true,
        moduleName: 'student',
        firstPage: false

      }
    }
  ]
})

router.beforeEach((to, from, next) => {

  if (!store.state.userInfo.screensRightsInformation.myprofile &&
    !store.state.flags.moduleChangingUsingMainMenu && !from.meta.backButtonAllowed &&
    from.meta.moduleName !== to.meta.moduleName && from.meta.firstPage && to.meta.firstPage && from.name !== null) {
    //store.commit(globalTypes.TOGGLE_MENU)
    next() // make sure to always call next()!
    return ''
  }
  if (!store.state.flags.moduleChangingUsingMainMenu && !from.meta.backButtonAllowed &&
    from.meta.moduleName !== to.meta.moduleName && from.meta.firstPage && to.meta.firstPage && from.name !== null) {
    store.commit(globalTypes.TOGGLE_MENU)
    next(false) // make sure to always call next()!
    return ''
  }
  if (from.name === 'Main Page' && to.meta.moduleName !== 'Connection' && store.state.userInfo.loggedInConnectionObject === null) {
    if (navigator.app) {
      navigator.app.exitApp()
    } else if (navigator.device) {
      navigator.device.exitApp()
    } else {
      window.close()
    }
    next(false)
    return ''
  }
  store.commit(globalTypes.MODULE_CHANGING_USING_MAIN_MENU, false)
  next()
})

export default router
